import { SITE } from "@/constants/testIds";

const PORTRAIT = "/images/mike-portrait.jpeg";

export default function About() {
  return (
    <section
      id="about"
      data-testid={SITE.about}
      className="relative bg-brand-cream py-24 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl gap-14 px-6 md:grid-cols-12 md:gap-20 md:px-10">
        <div className="relative md:col-span-5">
          <div className="relative overflow-hidden rounded-[2rem] shadow-2xl ring-1 ring-brand-evergreen/10">
            <img
              data-testid={SITE.aboutPortrait}
              src={PORTRAIT}
              alt="Mike — fly casting instructor, on the river in Southern Oregon"
              className="aspect-[4/5] w-full object-cover"
              loading="lazy"
            />
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-white/20" />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden rounded-2xl bg-brand-evergreen px-6 py-5 text-brand-cream shadow-xl md:block">
            <div className="font-display text-4xl leading-none">20</div>
            <div className="text-xs uppercase tracking-[0.2em] text-brand-cream/70">
              years on the water
            </div>
          </div>
        </div>

        <div className="md:col-span-7">
          <span className="text-xs uppercase tracking-[0.35em] text-brand-evergreen/60">
            About your instructor
          </span>
          <h2 className="mt-3 font-display text-4xl leading-tight text-brand-evergreen sm:text-5xl lg:text-6xl">
            Welcome to The Spirit of Fishing
          </h2>

          <div className="mt-8 space-y-6 text-lg leading-relaxed text-brand-charcoal/80">
            <p>
              With nearly twenty years of fly fishing experience, Mike has
              become grounded in the joy of connecting with nature and sharing
              his passion with others.
            </p>
            <p>
              Teaching people to fly cast grew naturally from that passion.
              Every lesson is an opportunity to slow down, learn something new,
              build confidence, and experience the peaceful rhythm of fly
              casting.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-brand-evergreen/10 pt-8 text-sm">
            <div>
              <div className="font-display text-3xl text-brand-evergreen">1–3</div>
              <div className="text-brand-charcoal/60">Students per lesson</div>
            </div>
            <div>
              <div className="font-display text-3xl text-brand-evergreen">20%</div>
              <div className="text-brand-charcoal/60">Goes to conservation</div>
            </div>
            <div>
              <div className="font-display text-3xl text-brand-evergreen">All</div>
              <div className="text-brand-charcoal/60">Levels welcome</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
